export const PRODUCT_TYPE = {
  // ALL: 'ALL',
  KIT: 'KIT',
  // Coach is still a real, historically-issued product type (existing products/orders reference
  // it), even though the admin Coach Program management pages have been removed; do not remove for now. Will have remove plan
  COACH_PROGRAM: 'COACH_PROGRAM',
  PROBIOTIC: 'PROBIOTIC',
  BUNDLE: 'BUNDLE',
};

export enum ProbioticType {
  IMMUNITY = 'IMMUNITY',
  ENERGY = 'ENERGY',
  STRENGTH = 'STRENGTH',
  WELL_BEING = 'WELL_BEING',
  MIND = 'MIND',
  OTHERS = 'OTHERS',
}

export const AMILI_PROBIOTIC_NAME: Record<string, string> = {
  [ProbioticType.IMMUNITY]: 'FORMULATION 1',
  [ProbioticType.ENERGY]: 'FORMULATION 5',
  [ProbioticType.STRENGTH]: 'FORMULATION 4',
  [ProbioticType.WELL_BEING]: 'FORMULATION 2',
  [ProbioticType.MIND]: 'FORMULATION 3',
};

export enum AmiliFormulationProbioticType {
  FORMULATION_1 = 'FORMULATION_1',
  FORMULATION_2 = 'FORMULATION_2',
  FORMULATION_3 = 'FORMULATION_3',
  FORMULATION_4 = 'FORMULATION_4',
}

export enum ProductType {
  KIT = 'KIT',
  // Coach is still a real, historically-issued product type (existing products/orders reference
  // it), even though the admin Coach Program management pages have been removed; do not remove for now. Will have remove plan
  COACH_PROGRAM = 'COACH_PROGRAM',
  PROBIOTIC = 'PROBIOTIC',
  BUNDLE = 'BUNDLE',
  FMT = 'FMT',
}

export enum CompositionType {
  COMPONENT = 'COMPONENT',
  PRODUCT = 'PRODUCT',
  RAW = 'RAW',
}

export const PRODUCT_TABS = {
  ALL: 'all',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

export enum ProductHistoryType {
  ORDER_PLACEMENT = 'ORDER_PLACEMENT',
  MANUAL_STOCK_ADJUSTMENT = 'MANUAL_STOCK_ADJUSTMENT',
  ORDER_DELETED = 'ORDER_DELETED',
  ORDER_RESTORED = 'ORDER_RESTORED',
  ORDER_CANCELLED = 'ORDER_CANCELLED',
  // Written by PUT /products/:id/stock whenever this product's quantity
  // change consumes/refunds a composed component's stock.
  USED_AS_COMPONENT = 'USED_AS_COMPONENT',
}

export const ProductHistoryTypeLabel: Record<string, any> = {
  [ProductHistoryType.ORDER_PLACEMENT]: 'orderPlacement',
  [ProductHistoryType.MANUAL_STOCK_ADJUSTMENT]: 'manualStockAdjustment',
  [ProductHistoryType.ORDER_DELETED]: 'orderDeleted',
  [ProductHistoryType.ORDER_RESTORED]: 'orderRestored',
  [ProductHistoryType.ORDER_CANCELLED]: 'orderCancelled',
  [ProductHistoryType.USED_AS_COMPONENT]: 'usedAsComponent',
};

export const ProductHistoryTypeLabelColor: Record<string, any> = {
  [ProductHistoryType.ORDER_RESTORED]: ['#007AE7', '#EBF5FD'],
  [ProductHistoryType.ORDER_DELETED]: ['#FFAC00', '#FFF9EB'],
  [ProductHistoryType.ORDER_CANCELLED]: ['#FF634E', '#FFF3F1'],
  [ProductHistoryType.ORDER_PLACEMENT]: ['#da2e9a', '#fceff7'],
  [ProductHistoryType.MANUAL_STOCK_ADJUSTMENT]: ['#232567', '#EEEEF3'],
  [ProductHistoryType.USED_AS_COMPONENT]: ['#00AB00', '#EBF9EB'],
};

export enum FmtBottleLogType {
  //to be remove
  ORDER_PLACEMENT = 'ORDER_PLACEMENT',
  BOTTLE_STOCK = 'BOTTLE_STOCK',
  //using this
  STOCK = 'STOCK', // = READY IN UI
  REMOVE_FROM_ORDER = 'REMOVE_FROM_ORDER', // = READY IN UI
  IN_ORDER = 'IN_ORDER', // = IN PROCESS IN UI
  SOLD = 'SOLD', // = SOLD IN UI
  CLINIC_RECEIVED = 'CLINIC_RECEIVED',
}
export const FmtBottleLogTypeLabelColor: Record<string, any> = {
  //to be remove
  [FmtBottleLogType.ORDER_PLACEMENT]: ['#da2e9a', '#fceff7'],
  [FmtBottleLogType.BOTTLE_STOCK]: ['#232567', '#EEEEF3'],

  //using this
  [FmtBottleLogType.IN_ORDER]: ['#da2e9a', '#fceff7'],
  [FmtBottleLogType.SOLD]: ['#da2e9a', '#fceff7'],
  [FmtBottleLogType.STOCK]: ['#232567', '#EEEEF3'],
  [FmtBottleLogType.REMOVE_FROM_ORDER]: ['#232567', '#EEEEF3'],
  [FmtBottleLogType.CLINIC_RECEIVED]: ['#da2e9a', '#fceff7'],
};
export const NOT_DISCOUNT_PRODUCTS = ['BIO & ME'];

export const DISCOUNT_QUANITY_LIMIT: Record<
  string,
  Record<
    string,
    {
      gte: number;
      lte?: number;
    }
  >
> = {
  [PRODUCT_TYPE.KIT]: {
    LEVEL_1: {
      gte: 10,
      lte: 24,
    },
    LEVEL_2: {
      gte: 25,
      lte: 149,
    },
    LEVEL_3: {
      gte: 150,
    },
  },
  [PRODUCT_TYPE.PROBIOTIC]: {
    LEVEL_1: {
      gte: 20,
      lte: 49,
    },
    LEVEL_2: {
      gte: 50,
      lte: 149,
    },
    LEVEL_3: {
      gte: 150,
    },
  },
};

export const DISCOUNT_TYPE: Record<string, Record<string, number>> = {
  [PRODUCT_TYPE.KIT]: {
    LEVEL_1: 0.35,
    LEVEL_2: 0.45,
    LEVEL_3: 0.55,
  },
  [PRODUCT_TYPE.PROBIOTIC]: {
    LEVEL_1: 0.35,
    LEVEL_2: 0.45,
    LEVEL_3: 0.55,
  },
};
